import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ClassificationField } from "../../../../../../models/classification-field";
import { SelectOperatorType } from "../../../../../../models/select-operator";
import { ClassificationControllerService } from "../../../../../../services/classifications-controller/classification-controller.service";
import { BaseError } from "../../../../base-error";
import { SelectSubjectType } from "../../../../../../models/select-subject";
import { BaseFieldDeterminantComponent } from "./base-field-determinant.component";

@Component({
  selector: "sub-catalog-determinant",
  templateUrl: "./sub-catalog-determinant.component.html",
  styles: [],
})
export class SubCatalogDeterminantComponent extends BaseFieldDeterminantComponent {

  public operators: string[];
  public SelectOperatorType = SelectOperatorType;
  @Input() public isTargetComponent: boolean;
  @Input() public parentCatalogFieldValue: ClassificationField;
  @Input() public parentCatalogId: string;
  @Input() public subCatalogFieldValue: ClassificationField;
  @Input() public classificationFields: ClassificationField[] = [];
  @Input() public subCatalogId: string;
  @Input() public operator: SelectOperatorType;
  public parentCatalogFields: ClassificationField[] = [];
  public subCatalogFields: ClassificationField[] = [];
  @Output() public parentCatalogValueResponse = new EventEmitter();
  @Output() public subCatalogValueResponse = new EventEmitter();
  @Output() public operatorResponse = new EventEmitter();
  public parentCatalogFieldValueId: string;
  public subCatalogFieldValueId: string;
  @Input() public fields: any[] = [];
  @Input() public sourceFormFieldKey: string;
  @Input() public isCatalogMultiple: boolean = false;
  @Input() public subject: SelectSubjectType;
  @Output() public catalogValueResponse = new EventEmitter();
  @Output() public subjectResponse = new EventEmitter();
  @Output() public changeClassificationFields = new EventEmitter();

  constructor(private classificationControllerService: ClassificationControllerService,
    public toastr: ToastrService,
    private cdr: ChangeDetectorRef) {
    super(toastr);
  }

  public ngOnInit() {
    console.log("SubCatalogDeterminantComponent ngOnInit", this.isTargetComponent, this.parentCatalogId, this.subCatalogId, this.operator);
    this.operators = Object.keys(SelectOperatorType);
    super.ngOnInit();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    console.log("--- ngOnChanges:", changes);
    if (changes.parentCatalogId) {
      if (changes.parentCatalogId.currentValue) {
        this.parentCatalogId = changes.parentCatalogId.currentValue;
        if (this.parentCatalogFieldValue) {
          const val = this.parentCatalogFieldValue as any;
          this.parentCatalogFieldValueId = val.id ? val.id : val;
        }
        if (this.subCatalogFieldValue) {
          this.subCatalogFieldValueId = this.subCatalogFieldValue as any;
        }
        this.loadCatalogFields();
      } else {
        console.log("--- parentCatalogId cleared, clearing parentCatalogFieldValueId");
        this.parentCatalogFieldValueId = null;
        this.parentCatalogFields = [];
        this.subCatalogFieldValueId = null;
        this.subCatalogFields = [];
      }
    }
    if (changes.parentCatalogFieldValue && changes.parentCatalogFieldValue.currentValue) {
      const val = changes.parentCatalogFieldValue.currentValue;
      this.parentCatalogFieldValueId = val.id ? val.id : val;
      console.log("--- parentCatalogFieldValueId changed:", this.parentCatalogFieldValueId);
    }
    if (changes.subCatalogId) {
      if (changes.subCatalogId.currentValue) {
        this.subCatalogId = changes.subCatalogId.currentValue;
        this.loadSubCatalogFields();
      } else {
        this.subCatalogFieldValueId = null;
        this.subCatalogFields = [];
      }
    }
    if (changes.subCatalogFieldValue && changes.subCatalogFieldValue.currentValue) {
      this.subCatalogFieldValueId = changes.subCatalogFieldValue.currentValue;
    }

    if (this.parentCatalogId && this.parentCatalogFields.length === 0) {
      this.loadCatalogFields();
    }

    super.ngOnChanges(changes);
  }

  public loadCatalogFields() {
    this.parentCatalogFields = [];
    if (this.parentCatalogId) {
      this.classificationControllerService.getClassificationsByType(this.parentCatalogId).subscribe(
        (data) => {
          this.parentCatalogFields = [...data];
          this.cdr.markForCheck();
          console.log("--- parentCatalogFields loaded:", this.parentCatalogFields.length, this.parentCatalogFields);
          console.log("--- Checking match for:", JSON.stringify(this.parentCatalogFieldValueId));
          if (this.parentCatalogFieldValueId) {
            const match = this.parentCatalogFields.find(f => f.id === this.parentCatalogFieldValueId);
            console.log("--- parentCatalog match:", match);
            if (match) {
              // Only emit if the current parent value is missing childClassificationType
              // or if we don't have the object reference to check.
              const currentParent = this.parentCatalogFieldValue as any;
              if (!currentParent || !currentParent.childClassificationType || currentParent.id !== match.id) {
                console.log("--- Emitting parentCatalogValueResponse because missing childClassificationType");
                this.parentCatalogValueResponse.emit(match);
              } else {
                console.log("--- Skipping parentCatalogValueResponse emit (already has childClassificationType)");
              }

              if (match.childClassificationType) {
                this.subCatalogId = match.childClassificationType.id;
                this.loadSubCatalogFields();
              }
            }
          }
        },
        (error) => this.showErrorMessageWithTitle("Error when loading catalogs", error),
      );
    }
  }

  public loadSubCatalogFields() {
    this.subCatalogFields = [];
    this.classificationControllerService.getClassificationsByType(this.subCatalogId).subscribe(
      (data) => {
        this.subCatalogFields = [...data];
        this.cdr.markForCheck();
        console.log("--- subCatalogFields loaded:", this.subCatalogFields.length, this.subCatalogFields);
        console.log("--- Checking subCatalog match for:", this.subCatalogFieldValueId);

        if (!this.subCatalogFieldValueId && this.subCatalogFields && this.subCatalogFields.length > 0) {
          // this.subCatalogValueResponse.emit(this.subCatalogFields[0]);
        }
      },
      (error) => this.showErrorMessageWithTitle("Error when loading sub catalogs", error),
    );
  }

  public selectParentCatalogValueChanged(newValue: string) {
    console.log("--- selectParentCatalogValueChanged", newValue);
    if (newValue) {
      this.parentCatalogFields.forEach((item) => {
        if (item != null && item.id === newValue) {
          if (item.childClassificationType) {
            this.subCatalogId = item.childClassificationType.id;
          } else {
            this.subCatalogId = null;
          }
          this.parentCatalogValueResponse.emit(item);
        }
      });
      this.subCatalogFieldValueId = null;
      this.loadSubCatalogFields();
    } else {
      console.log("--- selectParentCatalogValueChanged cleared parentCatalogFieldValueId");
      this.parentCatalogFieldValueId = null;
      this.parentCatalogValueResponse.emit(null);
    }
  }

  public selectSubCatalogValueChanged(newValue: string) {
    console.log("--- selectSubCatalogValueChanged", newValue);
    if (newValue) {
      this.subCatalogFields.forEach((item) => {
        if (item != null && item.id === newValue) {
          this.subCatalogValueResponse.emit(item);
        }
      });
    } else {
      this.subCatalogFieldValueId = null;
      this.subCatalogValueResponse.emit(null);
    }
  }

  public onTargetFormFieldKeyChange(event): void {
    this.sourceFormFieldKey = event;
    this.catalogValueResponse.emit({ sourceFormFieldKey: this.sourceFormFieldKey });
  }

  public updateClassificationFields(multipleFields) {
    console.log("--- updateClassificationFields", multipleFields);
    this.changeClassificationFields.emit(multipleFields.map((field) => field.id));
  }

  public filterSubjects(operator: any): SelectSubjectType[] {
    switch (operator) {
      case "EQUAL":
        return [SelectSubjectType.NONE, SelectSubjectType.SOME];
      case "NOT_EQUAL":
        return [SelectSubjectType.ALL, SelectSubjectType.SOME];
      case "IN":
      case "NOT_IN":
      default:
        return [SelectSubjectType.ALL, SelectSubjectType.NONE, SelectSubjectType.SOME];
    }
  }

  public operatorValueChanged() {
    // here we need to change subject
    this.operatorResponse.emit(this.operator);
    this.subject = this.filterSubjects(this.operator)[0];
    console.log("operator value changed ", this.operator);
    this.subjectValueChanged();
  }

  public subjectValueChanged() {
    console.log("subject value changed ", this.subject);
    this.subjectResponse.emit(this.subject);
  }

}
